
  import { defineComponent } from 'vue';

  import ContextMenu from '@/common/components/redesigned/ContextMenu/ContextMenu.vue';
  import ContextMenuItem from '@/common/components/redesigned/ContextMenu/ContextMenuItem.vue';

  import { LocalContextMenuActions } from './types';

  export default defineComponent({
    name: 'LocalContextMenu',
    components: {
      ContextMenu,
      ContextMenuItem,
    },
    props: {
      isVisible: {
        type: Boolean,
        default: false,
      },
      position: {
        type: Object as () => { top: number; right: number },
        required: true,
      },
    },
    emits: ['action', 'close'],
    methods: {
      handleClose() {
        this.$emit('close');
      },

      handleSelectAllChildren() {
        this.handleAction(LocalContextMenuActions.SELECT_ALL_CHILDREN);
      },

      handleSelectAllChildrenByLevel() {
        this.handleAction(LocalContextMenuActions.SELECT_ALL_CHILDREN_BY_LEVEL);
      },

      handleUnselectAllChildren() {
        this.handleAction(LocalContextMenuActions.UNSELECT_ALL_CHILDREN);
      },

      handleAction(action: LocalContextMenuActions) {
        this.$emit('action', action);
        this.$emit('close');
      },
    },
  });
